import {HotMatchReducer, ReducerFromState} from "../../../@types/reducers";
import {HotMatchObject} from "../../../@types/response";

export const getHotMatches = (state: ReducerFromState<HotMatchReducer>): HotMatchObject[] => state.hotMatch.hotMatches;
